import {setMiniSidenav, useMaterialUIController} from "./Context/mui";
import {useEffect, useMemo, useState} from "react";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import routes, {Page404} from "./routes";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import {AuthProvider} from "./utils/middlewares/AuthProvider";
import {CacheProvider} from "@emotion/react";
import {CssBaseline, ThemeProvider} from "@mui/material";
import themeRTL from "./Asset/theme/theme-rtl";
import {ToastContainer} from "react-toastify";
import Sidenav from "./Components/MDSideNav";
import 'react-toastify/dist/ReactToastify.css';
import {CurrentUser} from "./utils/Hooks/currentUser";

export default function App() {
    const [controller, dispatch] = useMaterialUIController();
    const {
        miniSidenav,
        direction,
        layout,
        sidenavColor,
        transparentSidenav,
        whiteSidenav,
        darkMode,
    } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);
    const [rtlCache, setRtlCache] = useState(null);
    const {pathname} = useLocation();

    // Cache for the rtl
    useMemo(() => {
        const cacheRtl = createCache({
            key: "rtl",
            stylisPlugins: [rtlPlugin],
        });

        setRtlCache(cacheRtl);
    }, []);

    // Open sidenav when mouse enter on mini sidenav
    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };

    useEffect(() => {
        document.body.setAttribute("dir", direction);
    }, [direction]);

    // Setting page scroll to 0 when changing the route
    useEffect(() => {

        document.documentElement.scrollTop = 0;
        if (document.scrollingElement) {
            document.scrollingElement.scrollTop = 0;
        }
        document.title = `قهرمان سلامت`;
    }, [pathname]);

    const getRoutes = (allRoutes) =>
        allRoutes.map((route) => {
            if (route.collapse) {
                return getRoutes(route.collapse);
            }
            if (route.childs) {
                return getRoutes(route.childs);
            }
            if (route.route) {
                return (
                    <Route
                        path={route.route}
                        element={<>
                            <AuthProvider routeName={route.route} level={route.level}>
                                {route.component}
                            </AuthProvider>
                        </>}
                        key={route.key}
                    />
                );
            }

            return null;
        });

    if (!rtlCache) return null;

    return (
        <CacheProvider value={rtlCache}>
            <ThemeProvider theme={themeRTL}>
                <CssBaseline/>
                {layout === "dashboard" && (
                    <>
                        <Sidenav
                            color={sidenavColor}

                            brandName={CurrentUser()?.user?.FullName}
                            routes={routes()}
                            onMouseEnter={handleOnMouseEnter}
                            onMouseLeave={handleOnMouseLeave}
                        />
                    </>
                )}
                <Routes>
                    {getRoutes(routes())}
                    <Route path="*" element={<Page404/>}/>
                </Routes>

            </ThemeProvider>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </CacheProvider>
    );
}
